import i18n from "i18next";
import ru from "./locales/ru";
import en from "./locales/en";

i18n.init({
  fallbackLng: "ru",
  lng: "ru",
  debug: false,
  resources: {
    en,
    ru,
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
